/*
 * @Author: 范向玲
 * @Date: 2022-10-20 18:46:03
 * @LastEditors: 曹健勇
 * @LastEditTime: 2023-03-07 17:31:09
 * @Description: 组织结构接口
 * @FilePath: \web\src\api\dataManagement\orgManage.js
 */
import axios from '@/utils/request';
import config from '@/config/config';
const { serveIp: { mine_ip, }, } = config;

export const getOrgTreeApi = (params) => {
  return config.isRequestError(axios.post(`/sys/org/tree`));
};
export const getOrgTreeListApi = (params) => {
  return axios.post(`/sys/org/tree`);
};

// 删除组织机构树节点
export const deleteOrgTreeApi = (data) => {
  return axios.delete(`/sys/org/remove/${data}`);
};

// 新增组织机构
export const addOrgTreeNode = (params) => {
  return config.isRequestError(axios.post('/sys/org/add', params));
};

// 编辑组织机构
export const editOrgTreeNode = (params) => {
  return config.isRequestError(axios.put('/sys/org/update', params));
};